import React from 'react';

class ContentWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render(){
        let p = this.props;
        return(
            <div className={ `simprakit-textarea-content-wrapper` }>
                { p.children }
            </div>
        )
    }
}

export default ContentWrapper;